import { queryClient } from "./queryClient.ts";
import { supabase } from "./supabase.ts";

/**
 * Leave nothing of the account on this device (D-33; GDPR review H2/M3):
 * runs on sign-out, after a successful account deletion, and when the API
 * answers ACCOUNT_DELETED. Clears the Supabase session (its own `sb-*` keys
 * go with it), every `instead.*` localStorage key — token, invite, drafts,
 * outbox, persisted query cache, feedback-button position, "seen" markers —
 * the session-scoped where-context, and the in-memory query cache.
 */
export async function wipeDevice(): Promise<void> {
  try {
    await supabase?.auth.signOut();
  } catch {
    // the session may already be invalid (deleted at the idp) — local state still goes
  }
  queryClient.clear();
  try {
    for (const key of Object.keys(localStorage)) if (key.startsWith("instead.")) localStorage.removeItem(key);
  } catch {
    // storage unavailable — nothing to wipe
  }
  try {
    sessionStorage.clear();
  } catch {
    // same
  }
}
